import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton,
} from '@mui/material';
import { IconX, IconMail, IconCopy, IconExternalLink } from '@tabler/icons-react';
import { enqueueSnackbar } from 'notistack';

interface ContactModalProps {
  open: boolean;
  onClose: () => void;
}

const ContactModal: React.FC<ContactModalProps> = ({ open, onClose }) => {
  const handleCopyEmail = () => {
    navigator.clipboard.writeText('hola@inversorhub.com');
    enqueueSnackbar('Email copiado al portapapeles', { variant: 'success' });
  };

  const handleOpenEmailApp = () => {
    window.open('mailto:hola@inversorhub.com', '_blank');
    enqueueSnackbar('Abriendo aplicación de email...', { variant: 'info' });
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2 },
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="h6" fontWeight="600">
            Contactar con soporte
          </Typography>
          <IconButton onClick={onClose} size="small">
            <IconX size={20} />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ mb: 3 }}>
          <Typography variant="body1" gutterBottom>
            Contacta con nuestro equipo de soporte para resolver dudas sobre tu cuenta, inversiones
            o cualquier aspecto técnico de la plataforma.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Respondemos en menos de 24 horas durante días laborables.
          </Typography>
        </Box>

        {/* Email Address Section */}
        <Box
          sx={{
            textAlign: 'center',
            py: 3,
            bgcolor: 'grey.50',
            borderRadius: 2,
            mb: 3,
          }}
        >
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Dirección de email
          </Typography>
          <Typography
            variant="h6"
            sx={{
              mb: 3,
              fontFamily: 'monospace',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1,
            }}
          >
            <IconMail size={20} />
            hola@inversorhub.com
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 3, pt: 0, gap: 1 }}>
        <Button
          variant="outlined"
          startIcon={<IconCopy size={16} />}
          onClick={handleCopyEmail}
          sx={{ borderRadius: 2, flex: 1, whiteSpace: 'nowrap' }}
        >
          Copiar email
        </Button>

        <Button
          variant="contained"
          startIcon={<IconExternalLink size={16} />}
          onClick={handleOpenEmailApp}
          sx={{ borderRadius: 2, flex: 1, whiteSpace: 'nowrap' }}
        >
          Abrir email
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContactModal;
